/**
 * Dealer-facing lead source labels (Milestone 27).
 */

export function formatDealerLeadSource(lead = {}) {
  const pageType = lead.conversionPageType || lead.landingPageType || lead.sourcePage || "";
  const component = lead.sourceComponent || "";
  const firstSource = lead.firstTouchSource || lead.utmSource || "";

  if (component.includes("buyer_quiz") || lead.leadType === "quiz_request") {
    return "Fuente: Quiz de comprador";
  }
  if (component.includes("recommendation") || pageType === "recommendation_results") {
    return "Fuente: Recomendaciones AutoMapa";
  }
  if (pageType.startsWith("seo_") || lead.seoPageSlug || component.startsWith("seo_")) {
    return "Fuente: Página SEO";
  }
  if (component.includes("guide") || pageType === "guide" || lead.guideSlug) {
    return "Fuente: Guía de compra";
  }
  if (pageType === "checklist" || component.includes("checklist")) {
    return "Fuente: Checklist de compra";
  }
  if (pageType === "dealer_profile" || component.includes("dealer_profile")) {
    return "Fuente: Perfil del concesionario";
  }
  if (pageType === "vehicle_detail" || component.includes("vehicle_detail") || component.includes("vehicle_contact")) {
    return "Fuente: Página del vehículo";
  }
  if (pageType === "search_results" || component.includes("search_result")) {
    return "Fuente: Búsqueda AutoMapa";
  }
  if (firstSource && firstSource !== "direct") {
    return "Fuente: Campaña";
  }
  return "Fuente: AutoMapa";
}

export function formatDealerLeadSourceDetail(lead = {}) {
  const parts = [formatDealerLeadSource(lead)];
  if (lead.landingPage) parts.push(`Entrada: ${lead.landingPage}`);
  if (lead.conversionPage && lead.conversionPage !== lead.landingPage) {
    parts.push(`Conversión: ${lead.conversionPage}`);
  }
  return parts.join(" · ");
}
